export const Timeline = () => ({
  "x-init"() {
    // this.$watch('hoverIndex', hoverIndexValue => {
    //   console.log(hoverIndexValue);
    // });

    this.$watch('activeIndex', activeIndexValue => {
      if (activeIndexValue === null) return;

      const timelineItems = this.$el.querySelector('.timeline__items');

      // Scroll to active card
      const smallestCardSize = [...this.$el.querySelectorAll('.timeline_card')]
        .sort((aCard, bCard) => aCard.clientWidth - bCard.clientWidth)
        [0].getBoundingClientRect().width;
      const gutter = parseInt(window.getComputedStyle(document.querySelector('.timeline__items')).columnGap);
      const pageGutterLeft = parseInt(window.getComputedStyle(document.querySelector('.timeline__items')).paddingLeft); // 20;
      const navPageOffset = this.$el.querySelector('.timeline__nav').getBoundingClientRect().left;
      const scrollToLeft = (smallestCardSize * activeIndexValue) + (gutter * activeIndexValue) - navPageOffset + pageGutterLeft


      timelineItems.scrollTo({
        top: 0,
        left: scrollToLeft,
        behavior: 'smooth',
      });


      // TODO: Scroll to timeline year
      if (this.$el.querySelector('.timeline__timeline').matches(':hover')) return;

      const yearsItems = this.$el.querySelector(`.timeline__timeline`);
      const yearsActiveItem = this.$el.querySelector(`.timeline__year[data-index="${activeIndexValue}"]`);
      const scrollYearsLeft = yearsActiveItem;
      yearsItems.scrollTo({
        top: 0,
        left: scrollYearsLeft.offsetLeft - gutter,
        behavior: 'smooth',
      });
    });
  },
  "@keyup.right.prevent"() {
    this.$data.activeIndex = this.$data.activeIndex + 1 < this.$data.itemCount ? this.$data.activeIndex + 1 : this.$data.activeIndex;
  },
  "@keyup.left.prevent"() {
    this.$data.activeIndex = this.$data.activeIndex >= 1 ? this.$data.activeIndex - 1 : this.$data.activeIndex;
    // console.log('l', this.$data.activeIndex);
  },
});

window.Alpine?.bind('Timeline', Timeline);
